var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.7895V22H22V17.7895M2 17.7895V2H22V17.7895M2 17.7895H6.21053M22 17.7895H19.3684M6.21053 17.7895L9.36842 12.5263L11.4737 15.1579L15.6842 9.36842L19.3684 17.7895M6.21053 17.7895H19.3684M9.36842 6.73684C9.36842 7.60887 8.6615 8.31579 7.78947 8.31579C6.91745 8.31579 6.21053 7.60887 6.21053 6.73684C6.21053 5.86481 6.91745 5.15789 7.78947 5.15789C8.6615 5.15789 9.36842 5.86481 9.36842 6.73684Z",
    stroke: "#4B9560",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.afd23efd023bac7ea5ba71f733e65df3.svg";
export { ForwardRef as ReactComponent };